import { Suspense, forwardRef, lazy } from 'react';
import { Skeleton } from '../ui';
import type { TreeGrid } from './types';

const paragraph = {
  rows: 10,
};

const LazyTreeGridComponent = lazy(() => {
  return (
    // @ts-ignore
    import('@iqx/tree-grid/GridED')
      .then(
        () =>
          new Promise(res => {
            // @ts-ignore
            TGLoadGridE('/tree-grid/GridE.js', res);
          }),
      )
      .then(() => {
        return import('./LazyTreeGridComponent');
      })
  );
});

export const TreeGridComponent = forwardRef<TreeGrid.Grid, TreeGrid.ComponentProps>(
  (props, ref) => {
    return (
      <Suspense fallback={<Skeleton active paragraph={paragraph} />}>
        <LazyTreeGridComponent {...props} ref={ref} />
      </Suspense>
    );
  },
);
